module.exports = __webpack_public_path__ + "static/media/AB_lock_green.c6078f4d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AB_lock_green.svg
// module id = 381
// module chunks = 0